import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from '../../components/features/dashboard/dashboard.component';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    children: [
      { path: 'companies/:alias', component: DashboardComponent },
      { path: 'projects/:project/:alias', component: DashboardComponent },
      { path: 'projects/:project', redirectTo: 'projects/:project/notes' },
      { path: 'opportunities/:opportunityId', component: DashboardComponent },
      { path: 'opportunities/:opportunityId/notes', component: DashboardComponent }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
